import { useRoutes } from "react-router-dom";
import routers from "./constants/router";
import {Amplify } from 'aws-amplify';
import { AmplifyConfig } from "./config";

Amplify.configure(AmplifyConfig);

const App = () => {
  let route = useRoutes(routers);
  return route;
};

export default App;
